import Client from "./Clients/AxiosClient";

const resource = "/api/v1/admin/bundles";
const productBundle = "api/v1/admin/product-bundles";

export default {
  get(payload) {
    return Client.get(`${resource}`, {
      params: {
        page: payload.page || 1,
        page_size: payload.page_size || 10,
        search: payload.search || "",
      },
    });
  },
  getDetail(id) {
    return Client.get(`${resource}/${id}`);
  },
  create(payload) {
    return Client.post(`${resource}`, payload, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
  },
  update(id, payload) {
    return Client.put(`${resource}/${id}`, payload, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
  },
  delete(id) {
    return Client.delete(`${resource}/${id}`);
  },

  createProductBundle(payload) {
    return Client.post(`${productBundle}/create-multiple`, payload);
  },
  deleteProductBundle(id) {
    return Client.delete(`${productBundle}/${id}`);
  },
  updateToggle(id, payload) {
    return Client.post(`${resource}/update/toggle/${id}`, payload);
  }
};
